/* eslint-disable */
import React from "react";
import themePropTypes from "../theme-prop-types";

const HorizontalGraphItem = ({ day, width, canShow }) => {
  return (
    <>
      {canShow ? (
        <div
          className='websdk-flex graph-day-item-web-sdk'
          data-testid='graph-day-item-web-sdk'
          style={{
            width: `${width}px`,
            height: `30px`
          }}
        >
          <p>{day}</p>
        </div>
      ) : null}
    </>
  );
};

HorizontalGraphItem.propTypes = themePropTypes.graph;
export default HorizontalGraphItem;
